import { api } from "@shared/api/client";
import type {
  RegisterFilterOptions,
  SpofCard,
  SpofSearchResult,
} from "../types";

/** One optional value per explorer selector; null means "all". */
export interface RegisterSelection {
  region: string | null;
  power_plant_id: string | null;
  unit: string | null;
  system: string | null;
  risk_category: string | null;
  keyword: string | null;
}

export const EMPTY_SELECTION: RegisterSelection = {
  region: null,
  power_plant_id: null,
  unit: null,
  system: null,
  risk_category: null,
  keyword: null,
};

/** Explorer column the backend ranks the register on. */
export type RegisterSortKey =
  | "spof_id"
  | "unit"
  | "description"
  | "power_loss_mw"
  | "risk_category"
  | "residual_risk_category"
  | "pid_link"
  | "mitigations";

export interface RegisterSort {
  key: RegisterSortKey;
  descending: boolean;
}

export const DEFAULT_SORT: RegisterSort = { key: "spof_id", descending: false };

export async function getRegisterFilterOptions(
  selection: RegisterSelection,
): Promise<RegisterFilterOptions> {
  const params = Object.fromEntries(
    Object.entries(selection).filter(([, value]) => value),
  );
  const { data } = await api.get<RegisterFilterOptions>(
    "/spof-register/filters",
    { params },
  );
  return data;
}

export async function searchRegister(
  selection: RegisterSelection,
  sort: RegisterSort,
  page: number,
  pageSize: number,
): Promise<SpofSearchResult> {
  const params = Object.fromEntries(
    Object.entries(selection).filter(([, value]) => value),
  );
  const { data } = await api.get<SpofSearchResult>("/spof-register", {
    params: {
      ...params,
      sort_by: sort.key,
      descending: sort.descending,
      page,
      page_size: pageSize,
    },
  });
  return data;
}

export async function getSpofCard(
  plantId: string,
  spofId: string,
): Promise<SpofCard> {
  const { data } = await api.get<SpofCard>(
    `/spof-register/${encodeURIComponent(plantId)}/${encodeURIComponent(spofId)}`,
  );
  return data;
}
